import { combineReducers } from "redux";
import pubnubMessage from "./messages/reducer";
import pubnubWorflow from "./workflow/reducer";

export default combineReducers({
  message: pubnubMessage,
  workflow: pubnubWorflow
});
